import { ConfigCount } from 'shared/model/statistic.model';

type Props = {
  item: ConfigCount;
};

const TopConfig = ({ item }: Props) => {
  return (
    <div className="top-config">
      <div>{item.name}</div>
      <div>{item.count}</div>
    </div>
  );
};

export default TopConfig;
